import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { StreamPage } from './stream';
import {NgxPaginationModule} from 'ngx-pagination';
import { TranslateModule } from '@ngx-translate/core';


@NgModule({
  declarations: [
    StreamPage,
  ],
  imports: [
    IonicPageModule.forChild(StreamPage),
    NgxPaginationModule,
    TranslateModule.forChild()
  ],
})
export class StreamPageModule {}



// WEBPACK FOOTER //
// ./src/pages/stream/stream.module.ts